@if (keyTransformMap(); as keyTransformMap) {
  <div class="flex flex-col gap-6 relative min-w-0" [style.minHeight.px]="containerMinHeight() || null" #cardsContainer>
    @for (group of stableGroups(); track group) {
      @if (group.type === MovableCardsContainerGroupTypeEnum.SingleColumn) {
        <div class="flex flex-col gap-6 min-w-0">
          @for (card of group.cards; track card.key) {
            @let directive = keyDirectiveMap()[card.key];
            <div
              class="flex flex-col min-w-0"
              [ngClass]="[dragIsInProgress() ? 'transition-transform' : '', draggedCardKey() === card.key ? 'z-dragged-item' : '']"
              [style.transform]="keyTransformMap[card.key] || ''"
              #cardContainer
            >
              @if (directive) {
                <ng-container *ngTemplateOutlet="directive.templateRef; context: directive.context"></ng-container>
              }
            </div>
          }
        </div>
      } @else {
        <div class="flex gap-6 min-w-0">
          <div class="flex flex-col gap-6 flex-1 min-w-0">
            @for (card of group.leftCards; track card.key) {
              @let directive = keyDirectiveMap()[card.key];
              <div
                class="flex flex-col min-w-0"
                [ngClass]="[
                  !!directive?.appMovableCardGrow() ? 'grow' : '',
                  dragIsInProgress() ? 'transition-transform' : '',
                  draggedCardKey() === card.key ? 'z-dragged-item' : '',
                ]"
                [style.transform]="keyTransformMap[card.key] || ''"
                #cardContainer
              >
                @if (directive) {
                  <ng-container *ngTemplateOutlet="directive.templateRef; context: directive.context"></ng-container>
                }
              </div>
            }
          </div>

          <div class="flex flex-col gap-6 flex-1 min-w-0">
            @for (card of group.rightCards; track card.key) {
              @let directive = keyDirectiveMap()[card.key];
              <div
                class="flex flex-col min-w-0"
                [ngClass]="[
                  !!directive?.appMovableCardGrow() ? 'grow' : '',
                  dragIsInProgress() ? 'transition-transform' : '',
                  draggedCardKey() === card.key ? 'z-dragged-item' : '',
                ]"
                [style.transform]="keyTransformMap[card.key] || ''"
                #cardContainer
              >
                @if (directive) {
                  <ng-container *ngTemplateOutlet="directive.templateRef; context: directive.context"></ng-container>
                }
              </div>
            }
          </div>
        </div>
      }
    }

    @if (dragAreasDebugMode) {
      @for (dragArea of dragAreas(); track dragArea) {
        <div
          class="absolute border bg-chargingstatus-faulted-30 pointer-events-none"
          [style.top.px]="dragArea.top - cardContainerRect().top"
          [style.left.px]="dragArea.left - cardContainerRect().left"
          [style.width.px]="dragArea.width"
          [style.height.px]="dragArea.height"
        ></div>
      }
    }
  </div>
}
